export const USER_STORAGE_KEY = 'snapshot-user';
export const TOKEN_STORAGE_KEY = 'snapshot-token';
export const VESSEL_STORAGE_KEY = 'snapshot-vessel';
export const USER_LOGIN_EVENT = 'user-logged-in';
export const USER_LOGOUT_EVENT = 'user-logged-out';
export const USER_AUTHOR_NAME_KEY = 'user-author-name';
